<template>
  <div class="">
    <Table :datas="agrupamentos" :height="200" stripe border>
        <TableItem className="estrutura-item-table" title="Nome" prop="clusterName" :width="135" />
        <TableItem className="estrutura-item-table" title="Quantidade de Revendedores" align="center" :render="getFormatCluesterMembers" prop="clusterMembers" :width="100" />
        <TableItem className="estrutura-item-table" align="center" :width="20">
          <template slot-scope="{data}">
          <button class="h-btn h-btn-s h-btn-blue" @click="handleOpenModal(data)">
            <i class="h-icon-edit"></i>
          </button></template>
        </TableItem>
    </Table>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapMutations, mapActions } = createNamespacedHelpers('revendedores');
const { mapState: mapStateEmpresas, mapMutations: mapMutationsEmpresas, mapActions: mapActionsEmpresas } = createNamespacedHelpers('empresas');
export default {
  name: 'TableEstruturas',
  data() {
    return {
    };
  },
  props: {
    refVendaDireta: {
      type: Object,
      require: true
    }
  },
  computed: {
    ...mapState({
      agrupamentos: state => state.agrupamentos
    })
  },
  methods: {
    ...mapMutationsEmpresas(['handleOpenModalEmpresas']),
    ...mapMutations(['setGrupos']),
    ...mapActions(['getEstruturaEdit']),
    async  handleOpenModal(data) {
      const { _id } = data;
      this.handleOpenModalEmpresas(false);
      await this.getEstruturaEdit(_id);
      this.$emit('AbrirModalEstruturas');
    },
    getFormatCluesterMembers(data) {
      if (!data) return 0;
      return data.clusterMembers
        ? data.clusterMembers.length
        : data.vendedores.length;
    }
  },
  async created() {
    const { _id } = this.refVendaDireta;
    const estruturas = await R.Cluster.listarTodos(1);
    this.setGrupos(estruturas.data.filter(g => g.refVendaDireta === _id));
  }
};
</script>
<style>
.estrutura-item-table{
 padding: 4px  !important;
 height: 0px !important;
 font-size: 12px !important;
}
</style>
